import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";
import { BookingForm } from "@/components/BookingForm";
import { ShieldCheck, Clock, PoundSterling, Phone } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function BookingPage() {
  return (
    <Layout>
      <Seo title="Book a Taxi" description="Book your fixed-price Gatwick airport transfer or local taxi online in under a minute. 24/7 licensed private hire from Clocktower Cars Gatwick." path="/book" />
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="text-brand font-semibold uppercase tracking-[0.2em] text-xs mb-3">Book now</p>
            <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight leading-tight">Book your journey</h1>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              Fill in your journey details and our team will call you back with a fixed fare and confirmation. Prefer to talk? We're here 24/7.
            </p>
            <div className="mt-10 space-y-5">
              <div className="flex items-start gap-4">
                <span className="grid place-items-center h-11 w-11 rounded-xl bg-brand-50 text-brand shrink-0"><ShieldCheck className="h-6 w-6" strokeWidth={1.75} /></span>
                <div><p className="text-slate-900 font-semibold">Licensed & insured</p><p className="text-sm text-slate-500">Fully licensed private hire operator.</p></div>
              </div>
              <div className="flex items-start gap-4">
                <span className="grid place-items-center h-11 w-11 rounded-xl bg-brand-50 text-brand shrink-0"><Clock className="h-6 w-6" strokeWidth={1.75} /></span>
                <div><p className="text-slate-900 font-semibold">Round the clock</p><p className="text-sm text-slate-500">Early flights and late nights covered.</p></div>
              </div>
              <div className="flex items-start gap-4">
                <span className="grid place-items-center h-11 w-11 rounded-xl bg-brand-50 text-brand shrink-0"><PoundSterling className="h-6 w-6" strokeWidth={1.75} /></span>
                <div><p className="text-slate-900 font-semibold">Fixed fares</p><p className="text-sm text-slate-500">Know your price before you travel.</p></div>
              </div>
            </div>
            <a href={`tel:${COMPANY.phoneRaw}`} className="mt-10 inline-flex items-center gap-2 border border-slate-300 hover:border-brand text-slate-700 hover:text-brand px-6 py-3 rounded-lg transition-colors">
              <Phone className="h-4 w-4 text-brand" /> {COMPANY.phone}
            </a>
          </div>
          <div className="lg:col-span-7">
            <BookingForm />
          </div>
        </div>
      </section>
    </Layout>
  );
}
